import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { http } from "@next-core/http";
/**
 * @description 搜索实例
 * @endpoint POST /object/:objectId/instance/_search
 */
export var InstanceApi_postSearch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (objectId, data, options) {
    return (/**! @contract easyops.api.cmdb.instance.PostSearch@1.1.0 */(yield http.post("api/gateway/cmdb.instance.PostSearch/object/".concat(objectId, "/instance/_search"), data, options)).data
    );
  });
  return function InstanceApi_postSearch(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=postSearch.js.map